// extracted by mini-css-extract-plugin
module.exports = {"container":"_2pOHZVYVLRFHRPe1fKOSDX","cancelBtn":"inDw7PBJRR2r_A1G931Fl","icon":"_7HrGf-feU3yijS8twBx6R","saveBtn":"H2fxcOy2uDTpUeIMDZQeh"};